import React from "react";

import { useNavigate } from "react-router-dom";

import {

    BookOpen,

    ArrowRight

} from "lucide-react";

import "./ContinueLearningCard.css";

const ContinueLearningCard = () => {

    const navigate = useNavigate();

    return (

        <div className="continue-card">

            <div className="continue-header">

                <div>

                    <h3>

                        Learning Hub

                    </h3>

                    <p>

                        Continue your learning journey.

                    </p>

                </div>

                <BookOpen

                    size={30}

                />

            </div>

            <div className="continue-content">

                <h4>

                    📚 Access your courses

                </h4>

                <p>

                    Learn, practice and improve your
                    performance with guided training
                    programs.

                </p>

            </div>

            <button

                className="continue-btn"

                onClick={() =>

                    navigate(

                        "/ignite/courses"

                    )

                }

            >

                Open Courses

                <ArrowRight size={18}/>

            </button>

        </div>

    );

};

export default ContinueLearningCard;